import React, { useState } from "react"
import { Card, CardBody, Collapse, Table } from "reactstrap"
import { useNavigate } from "react-router-dom"
import CustomHeaderTitle from "components/Common/CustomHeaderTitle"
import MonitorQuantificationFilter from "./filter"
import MonitorQuantificatinRenderItem from "./renderItem"

const MonitorQuantificationReportListComponent = ({
  data,
  error,
  loading,
  onExportBtnClick,
  onSearchHandler,
  exportStatus,
}) => {
  const navigate = useNavigate()
  const [filterOpen, setFilterOpen] = useState(false)
  const [filter, setFilter] = useState({})

  const onAdvancedSearchHandler = result => {
    setFilterOpen(result)
  }

  const onAdvancedSearchSubmit = data => {
    setFilter(data)
    onSearchHandler(data)
  }

  return (
    <React.Fragment>
      <Card>
        <CardBody>
          <CustomHeaderTitle
            loading={loading}
            title={"Quantification Report"}
            lgColumn={7}
            exportBtn={true}
            exportBtnLoading={exportStatus?.loading}
            onExportBtnClick={onExportBtnClick}
            rowCount={false}
            searchBox={false}
            rightBtn={false}
            advnacedSearchBtn={true}
            advnacedSearchBtnTitle={"Filter"}
            onAdvancedSearch={onAdvancedSearchHandler}
          />
          <Collapse isOpen={filterOpen}>
            <MonitorQuantificationFilter
              loading={loading}
              error={error}
              onAdvancedSearchSubmit={onAdvancedSearchSubmit}
            />
          </Collapse>

          <MonitorQuantificatinRenderItem data={data} />
        </CardBody>
      </Card>
    </React.Fragment>
  )
}

export default MonitorQuantificationReportListComponent
